export const NAME = 'settings';

export const TABS = {
	notificationSending: 198,
	informationCreation: 160,
	marketPlaceAgencies: 204,
};

export const notificationSetIds = {
	TASKS: 101,
	INFORMATION: 102,
	LEADS: 103,
	TASKS_SUBS: 201,
	INFORMATION_SUBS: 202,
	LEADS_SUBS: 203,
	REQ_2_SELL: 401,
	BACKOFFICE_UNRESOLVED: 801,
	SUMMARY_ESC_SUP: 901,
	MY_TASKS_AND_INFOS: 501,
	SUBS_TASKS_AND_INFOS: 502,
	TASK_CREATION_FAIL: 1001,
	TASK_CREATION: 1101,
	LEAD_ESCALATION: 1201,
	EOBCHODNIK_PUSH_NOTIFS_TASK_CREATION: 1301,
	LEAD_ESCALATION_UNRESOLVED: 1401,
	TASK_AND_INFO_FOR_SAN_MARCO: 1501,
	SMS_NOTIFICATIONS: 1601,
	PORTFOLIO_LEAD_CREATION: 1701,
	PORTFOLIO_LEAD_ESCALATION: 1801,
	EOBCHODNIK_PUSH_NOTIFS_LEAD_CREATION: 1901,
	LOSS_CLIENT_SME_TASKS_REPORT: 2001,
	ASSIGNED_CONTACTS_REGIONAL_MANAGER: 1,
	ASSIGNED_CONTACTS_ADMINISTRATION: 2,
	ASSIGNED_CONTACTS_GROUP_MANAGER: 3,
	PRODUCTION_CONTROL: 4,
	EOBCHODNIK_PUSH_NOTIFS_CONTACT_ASSIGN: 5,
	EOBCHODNIK_PUSH_NOTIFS_CAMPAIGN_NEAR_END: 6,
};

export const emailNotificationSetIds = {
	SUMMARY_NOTIF_EMAIL: 101,
	TASK_AND_INFOS_EMAIL: 502,
	TASK_CREATION_FAIL_EMAIL: 1001,
};

export const emailNotificationIdsMapToFields = {
	101: 'summaryNotificationsEmail',
	502: 'tasksAndInformationByEmailEmail',
	1001: 'taskCreationFailEmail',
};

export const idsWithTooltip = {
	tasks: [62, 66, 15, 60, 20, 68, 12, 72],
	leads: [108, 109, 107, 110],
};
